import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, vShow as _vShow, createBlock as _createBlock, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass({
      'dashboard-wrapper': true,
      }),
  style: {
      padding: '30px 30px 30px 30px',
    }
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "box-title" }
const _hoisted_6 = {
  class: /*@__PURE__*/_normalizeClass({
      })
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_question_answer = _resolveComponent("question-answer")!
  const _component_ciena_layout = _resolveComponent("ciena-layout")!

  return (_openBlock(), _createBlock(_component_ciena_layout, null, {
    "header-left": _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("span", { class: "heading-4 f-roboto fw-light" }, "EPX Dashboard", -1)
    ]))]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", _hoisted_5, "Company " + _toDisplayString(_ctx.id) + " contractor " + _toDisplayString(_ctx.userId), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (question, ix) => {
              return (_openBlock(), _createElementBlock("div", {
                key: question.id,
                class: _normalizeClass({
          })
              }, [
                _withDirectives((_openBlock(), _createBlock(_component_question_answer, {
                  key: question.id,
                  ix: ix + 1,
                  question: question,
                  "is-active": false,
                  error: '',
                  count: ix + 1,
                  onHandleClick: () => {},
                  onHandleValueUpdate: _ctx.handleValueUpdate,
                  onRemoveQuestion: () => {},
                  onHandleAddQuestion: () => {}
                }, null, 8, ["ix", "question", "count", "onHandleValueUpdate"])), [
                  [_vShow, true]
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}